<template>
  <div class="management-contract">
    <el-form ref="form" :model="filtersForm" label-width="80px" inline>
      <el-row>
        <el-form-item label="处方编号">
          <el-input
            v-model="filtersForm.orderNo"
            placeholder="请输入处方单号"
          ></el-input>
        </el-form-item>
        <el-form-item label="处方类型">
          <el-select v-model="filtersForm.orderType">
            <el-option
              v-for="item in orderTypeList"
              :value="item.value"
              :key="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开方医院">
          <el-select v-model="filtersForm.hos">
            <el-option
              value="燕化医院"
              key="燕化医院"
              label="燕化医院"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="开方医生">
          <el-input
            v-model="filtersForm.docName"
            placeholder="请输入患者姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="患者姓名">
          <el-input
            v-model="filtersForm.compatName"
            placeholder="请输入患者姓名"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clearSearch">重置</el-button>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-row>
    </el-form>
    <el-radio-group v-model="checkedStatus">
      <el-radio-button
        v-for="state in states"
        :label="state.label"
        :key="state.text"
        >{{ state.text }}
      </el-radio-button>
    </el-radio-group>
    <el-table :data="list" v-loading="loading" border>
      <el-table-column prop="orderNo" label="处方编号"></el-table-column>
      <el-table-column
        prop="status"
        :formatter="formatterStatus"
        label="处方状态"
      ></el-table-column>
      <el-table-column
        prop="orderType"
        :formatter="formatterType"
        label="处方类型"
      ></el-table-column>
      <el-table-column prop="diagnosis" label="诊断"></el-table-column>
      <el-table-column prop="hosName" label="开方医院"></el-table-column>
      <el-table-column prop="docName" label="开方医生"></el-table-column>
      <el-table-column
        prop="createTime"
        :formatter="formatterCreateTime"
        label="开方时间"
      ></el-table-column>
      <el-table-column prop="auditorName" label="审核药师"></el-table-column>
      <el-table-column
        prop="auditTime"
        :formatter="formatterAuditTime"
        label="审核时间"
      ></el-table-column>
      <el-table-column prop="compatName" label="患者姓名"></el-table-column>
      <el-table-column
        prop="compatGender"
        label="患者性别"
        :formatter="formatterSex"
      ></el-table-column>
      <el-table-column prop="compatAge" label="患者年龄"></el-table-column>
      <el-table-column v-if="checkedStatus === 'REBACK'" label="拒绝原因">
        <template slot-scope="scope">
          <span :title="scope.row.cancelReason" class="color_red">{{
            scope.row.cancelReason
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            @click.prevent="showCheckDialog(scope.row.id)"
            type="primary"
            size="small"
          >
            {{ scope.row.status == "ISSUE" ? "审核" : "详情" }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row class="pagination-wrapper" type="flex" justify="end">
      <el-pagination
        layout="prev, pager, next"
        :current-page.sync="page.pageNum"
        :total="page.total"
        @current-change="onCurrentChange"
      ></el-pagination>
    </el-row>
    <check-dialog
      ref="checkDialog"
      :info="orderInfo"
      @handler="checkHandler"
    ></check-dialog>
  </div>
</template>

<script>
import { MessageBox, Message } from "element-ui";
import axiosUtil from "../../utils/AxiosUtils.js";
import { tokenCache } from "../../../cache/tokenCache";
import { timeFormat } from "ty-vue-filters";
import { ORDER_TYPE_LIST } from "../../lib/config";
import { sexFilter } from "../../lib/filters";
import CheckDialog from "../prescription/check-dialog";

const PAGE = {
  pageNum: 1,
  // pageSize: 10,
  pageSize: 10,
  pages: 1,
  total: 0,
};
export default {
  data() {
    return {
      orderInfo: {},
      daterange: [],
      filtersForm: {
        orderNo: "",
        patName: "",
        orderType: "",
        hos: "燕化医院",
        // startDate: "",
        // endDate: ""
      },
      list: [],
      orderTypeList: ORDER_TYPE_LIST,
      states: [
        {
          label: "ISSUE",
          text: "待审核",
        },
        {
          label: "AUDIT",
          text: "已审核",
        },
        {
          label: "",
          text: "全部",
        },
      ],
      loading: false,
      page: PAGE,
      checkedStatus: "ISSUE",
    };
  },
  components: { CheckDialog },
  watch: {
    daterange(val) {
      this.filtersForm.startDate = val ? val[0] : "";
      this.filtersForm.endDate = val ? val[1] : "";
    },
    checkedStatus: {
      handler() {
        this.pages = PAGE;
        this.getList();
      },
      immediate: true,
    },
  },
  mounted() {
    console.log(this.orderTypeList);
  },
  methods: {
    clearSearch() {
      this.filtersForm = {
        orderNo: "",
        patName: "",
        orderType: "",
        hos: "燕化医院",
      };
    },
    async showCheckDialog(id) {
      const { code, obj, msg } = await this.$http(
        "smarthos.recipe.order.info",
        { orderId: id }
      );
      if (code == 0) {
        this.orderInfo = obj;
        this.$refs.checkDialog.show();
      } else {
        this.$message.error(msg);
      }
    },
    checkHandler(h) {
      if (h == "refuse") {
        this.onRefuse();
      } else {
        this.onAccept();
      }
    },
    onRefuse() {
      MessageBox.prompt("请输入拒绝理由?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(async (inputValue) => {
          const options = {
            orderId: this.orderInfo.id,
            status: "REFUSE",
            reason: inputValue.value,
            token: tokenCache.get(),
          };
          const { code, obj, msg } = await this.$http(
            "smarthos.recipe.order.fenghuang.new.audit",
            options
          );
          if (code == "0") {
            this.$refs.checkDialog.close();
            this.getList();
          } else {
            this.$message.error(msg);
            this.$refs.checkDialog.close();
          }
        })
        .catch(() => {
          return;
        });
    },
    async confirm(value, id) {
      if (value.value == null) {
        Message({
          showClose: true,
          message: "请输入短信验证码",
          type: "error",
        });
        return;
      }
      let that = this;
      let options = {
        token: localStorage.getItem("token"),
        orderId: that.orderInfo.id,
        businessType: "AUDIT_RECIPE",
        verificationCode: value.value,
        docId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,
      };
      let res = await this.$http(
        "smarthos.recipe.order.sign.send.code.check",
        options
      );
      if (res.code == 0) {
        that.signature();
      }
    },
    async signature() {
      let that = this;
      let options = {
        token: localStorage.getItem("token"),
        orderId: that.orderInfo.id,
        status: "AUDIT",
      };
      let res = await this.$http(
        "smarthos.recipe.order.fenghuang.new.audit",
        options
      );
      if (res.code == 0) {
        Message({
          showClose: true,
          message: "审核成功",
          type: "success",
        });
        that.$refs.checkDialog.close();
        that.getList();
      }
    },
    async VerificationCode() {
      let that = this;
      let options = {
        token: localStorage.getItem("token"),
        orderId: this.orderInfo.id,
        businessType: "AUDIT_RECIPE",
        docId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,
      };
      let res = await this.$http(
        "smarthos.recipe.order.sign.send.code",
        options
      );
      if (res.code == 0) {
        MessageBox.prompt("请输入短信验证码", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
          .then(async (inputValue) => {
            that.confirm(inputValue);
          })
          .catch(() => {
            return;
          });
      }
    },
    onAccept() {
      let that = this;
      that
        .$confirm("即将给您本人手机号发送短信验证是否本人", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          that.VerificationCode();
        })
        .catch(() => {});
      // MessageBox.confirm('确定进行此操作', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      // }).then(async () => {
      //   const options = {
      //     orderId: this.orderInfo.id,
      //     status: 'AUDIT',
      //     token: tokenCache.get()
      //   };
      //   const {code, obj, msg} = await this.$http('smarthos.recipe.order.fenghuang.new.audit', options)
      //   if (code == '0') {
      //     this.$refs.checkDialog.close()
      //     this.getList();
      //   }
      //   else {
      //     this.$message.error(msg)
      //     this.$refs.checkDialog.close()
      //   }
      // })
    },

    goToDetails(id) {
      this.$router.push({
        path: "/main/management-contract-details",
        query: { id },
      });
    },
    async reCall(id) {
      MessageBox.confirm("确认召回处方?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let options = {
            token: localStorage.getItem("token"),
            orderId: id,
          };
          let res = await this.$http("smarthos.recipe.order.recall", options);
          if (res.code == 0) {
            Message({
              showClose: true,
              message: "操作成功",
              type: "success",
            });
          }
        })
        .catch(() => {});
    },
    onSubmit() {
      this.getList();
    },
    onCurrentChange(pageNum) {
      this.page.pageNum = pageNum;
      this.getList();
    },
    async getList() {
      this.loading = true;
      const options = {
        status: this.checkedStatus,
        token: tokenCache.get(),
        ...this.page,
        ...this.filtersForm,
      };
      const { code, list, page, msg } = await this.$http(
        "smarthos.recipe.order.auditor.list.page",
        options
      );
      if (code === "0") {
        this.loading = false;
        this.list = list;
        this.page = page;
      } else {
        this.$message.error(msg);
      }
    },
    formatterAuditTime(row, column, auditTime) {
      return timeFormat(auditTime, "%Y/%m/%d %H:%M");
    },
    formatterCreateTime(row, column, createTime) {
      return timeFormat(createTime, "%Y/%m/%d %H:%M");
    },
    formatterSex(row, column, compatGender) {
      return sexFilter(compatGender, 1);
    },
    formatterType(row, column, code) {
      const orderType = {
        WESTERN_RECIPE: "西药方",
        CHINESE_RECIPE: "草药方",
        PRESCRIPT_RECIPE: "成药方",
      };
      return orderType[code];
    },
    formatterStatus(row, column, code) {
      const statusObj = {
        REBACK: "待发布",
        ISSUE: "待审核",
        AUDIT: "已审核",
        PAY: "已审核",
        SHIPPING: "已审核",
        COMPLETE: "已审核",
        COMMENT: "已审核",
        CANCEL: "已作废",
      };
      return statusObj[code];
    },
    formatterSubStatus(row, column, code) {
      const statusObj = {
        REFUSE: "已拒绝",
        RECALL: "已召回",
      };
      return statusObj[code];
    },
  },
};
</script>

<style lang="scss">
.management-contract {
  .el-form {
    padding-top: 22px;
    border-top: 1px solid #f5f5f5;
  }
  .el-table {
    margin-top: 15px;
  }
  .pagination-wrapper {
    padding: 20px 0;
  }
  .el-table .cell {
    max-height: 69px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
}
</style>
